export default "__VITE_ASSET__DIO6Z9V$__"